import React, { useEffect, useRef, useState } from 'react';
import store from './journalStore';

/* Loads a private photo by id (sends the passcode), shows a skeleton while
   loading, and revokes its object URL on unmount to avoid memory leaks. */

export default function PhotoImg({ passcode, id, alt, className, onClick }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  const urlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    setUrl(null);
    setErr(false);
    (async () => {
      try {
        const u = await store.photoUrl(passcode, id);
        if (cancelled) {
          if (u && u.startsWith('blob:')) URL.revokeObjectURL(u);
          return;
        }
        urlRef.current = u;
        setUrl(u);
      } catch (e) {
        if (!cancelled) setErr(true);
      }
    })();
    return () => {
      cancelled = true;
      if (urlRef.current && urlRef.current.startsWith('blob:')) URL.revokeObjectURL(urlRef.current);
      urlRef.current = null;
    };
  }, [passcode, id]);

  if (err) return <div className={`aj-photo-skeleton aj-photo-err ${className || ''}`}>🥲</div>;
  if (!url) return <div className={`aj-photo-skeleton ${className || ''}`} />;
  return <img src={url} alt={alt || ''} className={className} onClick={onClick} draggable={false} />;
}
